module.exports = __webpack_public_path__ + "img/hunter.4a520924.png";